<template>
  <a-tooltip :placement="titlePosition" v-if="title">
    <template slot="title">
      <div :style="nowObj">
        <span>{{title}}</span>
      </div>
    </template>
    <span>
      <sys-icon class="icon" :type="type" :class="className" :style="styleObj" />
    </span>
  </a-tooltip>
  <sys-icon class="icon" :type="type" v-else :class="className" :style="styleObj" />
</template>

<script>
  import './iconfont'

  const iconfont = window._iconfont_svg_string_535975
  const iconfontId = 'pt-iconfont-symbols'

  function ensureIconfont () {
    if (typeof document === 'undefined' || !iconfont || document.getElementById(iconfontId)) return
    const container = document.createElement('div')
    container.id = iconfontId
    container.innerHTML = iconfont
    const svg = container.querySelector('svg')
    if (svg) {
      svg.setAttribute('aria-hidden', 'true')
      svg.style.position = 'absolute'
      svg.style.width = '0'
      svg.style.height = '0'
      svg.style.overflow = 'hidden'
    }
    document.body.insertBefore(container, document.body.firstChild)
  }

  ensureIconfont()

  const SysIcon = {
    name: 'SysIcon',
    functional: true,
    props: {
      type: {
        type: String,
        required: true
      }
    },
    render (h, context) {
      ensureIconfont()
      const { data, props } = context
      return h('i', {
        ...data,
        class: ['anticon', data.class],
        staticClass: data.staticClass
      }, [
        h('svg', {
          attrs: {
            focusable: 'false',
            'aria-hidden': 'true'
          },
          style: {
            width: '1em',
            height: '1em',
            fill: 'currentColor'
          }
        }, [
          h('use', {
            attrs: {
              href: `#${props.type}`,
              'xlink:href': `#${props.type}`
            }
          })
        ])
      ])
    }
  }

  export default {
    name: 'ptIcon',
    props: {
      titlePosition: {
        type: String,
        default: 'top'
      },
      title: {
        type: String,
        default: null
      },
      placement: {
        type: String,
        default: 'top'
      },
      type: {
        type: String,
        required: true
      },
      className: {
        type: String,
        default: 'myicon'
      },
      styleObj: {
        type: [Object, String],
        default: () => { return {} }
      },
      nowObj: {
        type: Object,
        default: () => {
          return {
            'white-space': 'nowrap'
          }
        }
      }
    },
    components: {
      SysIcon
    }
  }
</script>

<style scoped>
  .icon {
    cursor: pointer;
  }
</style>
